import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    import("@rolemodel/spider/dist/components/pdf-viewer/index.js")
  }
}
